module.exports = __webpack_public_path__ + "img/hide_layer.f7770982.svg";